const operatorRoles = ['googleadadmin', 'owadmin', 'owprovider']
const userRoles = ['googleadmanager', 'owpartner', 'owuser']

export function normalizedRoles(user = {}) {
  return [user?.role, user?.roles]
    .reduce((roles, value) => roles.concat(Array.isArray(value) ? value : [value]), [])
    .filter(Boolean)
    .map(role => String(role).trim().toLowerCase())
}

export function isDashboardAdmin(user) {
  return normalizedRoles(user).includes('admin')
}

export function hasOfferWallOperatorRole(user) {
  return normalizedRoles(user).some(role => operatorRoles.includes(role))
}

// Full dashboard admins retain their normal UI even with an additional OW role.
export function isOfferWallOperator(user) {
  return !isDashboardAdmin(user) && hasOfferWallOperatorRole(user)
}

export function hasOfferWallUserRole(user) {
  return normalizedRoles(user).some(role => userRoles.includes(role))
}

export function canAccessOfferWall(user) {
  return isDashboardAdmin(user) || hasOfferWallOperatorRole(user) || hasOfferWallUserRole(user)
}

export function accountUpdatePayload(account, viewer) {
  const payload = { ...account }
  if (!isDashboardAdmin(viewer)) delete payload.parent_id
  return { account: payload }
}
